module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("For students past and present at Winkfield Place"), _c('br'), _vm._v("\nand the Cordon Bleu Cookery School")])]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("This new edition published in 2011 by"), _c('br'), _vm._v("\nGrub Street"), _c('br'), _vm._v("\n4 Rainham Close"), _c('br'), _vm._v("\nLondon"), _c('br'), _vm._v("\nSW11 6SS"), _c('br'), _vm._v("\nEmail: ")]), _c('a', {
    attrs: {
      "href": "mailto:food@grubstreet.co.uk"
    }
  }, [_vm._v("food@grubstreet.co.uk")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.grubstreet.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.grubstreet.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Copyright this edition © Grub Street 2011")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("First published by J.M. Dent & Sons Ltd, 1956"), _c('br'), _vm._v("\nReprinted 1957, 1958, 1960, 1961, 1964, 1967"), _c('br'), _vm._v("\nReprinted with corrections and minor revisions 1971"), _c('br'), _vm._v("\nReissued 1978, Reprinted 1983, Reissued 1990"), _c('br'), _vm._v("\nReissued by Grub Street 2004")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Designed and formatted by Sarah Driver"), _c('br'), _vm._v("\nLine Drawings by Fred van Deelen")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("British Library Cataloguing in Publication Data"), _c('br'), _vm._v("\nSpry, Constance"), _c('br'), _vm._v("\n    The Constance Spry cookery book"), _c('br'), _vm._v("\n1.  Cookery"), _c('br'), _vm._v("\nI.  Title II. Hume, Rosemary"), _c('br'), _vm._v("\n641.5")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN 978-1-908117-17-5"), _c('br'), _vm._v("\nEPUB ISBN: 9781610047142")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means,"), _c('br'), _vm._v("\nelectronic or mechanical, including photocopying, recording or any information storage and retrieval"), _c('br'), _vm._v("\nsystem, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('b', [_vm._v("Publisher’s note to this edition")]), _c('br'), _vm._v("\nAll that we have done to this classic cookbook is to add metric measurements to all the recipes to assist"), _c('br'), _vm._v("\nthe present day cook. The integrity of the original 1956 text remains untouched and unaltered. Hence"), _c('br'), _vm._v("\nyou will still find references to pre-decimal coinage, shops that are now long disappeared and terminology"), _c('br'), _vm._v("\nwhich may to the modern reader sound quaint and outmoded. We had no wish, nor did we"), _c('br'), _vm._v("\nfeel it necessary, to update the language of a wonderful period piece which offers a valuable insight"), _c('br'), _vm._v("\ninto a bygone age.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 60
// module chunks = 0